/**
 * Rights of the mail dialogs, checked before the action so nothing fails with a 403 afterwards: sending needs
 * SEND_MAIL_AS_CUSTOMER (the services render the mails of a send themselves), looking at the mails before the send
 * ("Mail vorher ansehen") additionally RENDER_MAIL_TEMPLATES. Pure, no Vue.
 */
import {CustomAccessKeys} from '@/classes/clientOnly/permissionTreeResources/enums/CustomAccessKeys';

export interface MailRights {
    /** The send endpoint accepts the user */
    canSend: boolean;
    /** The preview endpoint accepts the user ("Mail vorher ansehen") */
    canPreview: boolean;
    /** Hint for the dialog ('' = everything possible) */
    hint: string;
}

const SEND_LABEL = '„E-Mails über die in den Stammdaten hinterlegte Adresse versenden“';
const RENDER_LABEL = '„E-Mail-Templates rendern“';

/**
 * Every send endpoint needs only SEND_MAIL_AS_CUSTOMER (feature/mail-ux)
 * @param manager $$crudAccessManager
 */
export function mailRights(manager: { getCustom: (key: CustomAccessKeys) => unknown } | undefined | null): MailRights {
    const send = !!manager?.getCustom(CustomAccessKeys.SEND_MAIL_AS_CUSTOMER);
    const render = !!manager?.getCustom(CustomAccessKeys.RENDER_MAIL_TEMPLATES);
    const canSend = send;
    const canPreview = send && render;
    let hint = '';
    if (!send) {
        hint = `Du darfst keine Mails versenden – dafür fehlt dir das Recht ${SEND_LABEL}.`;
    } else if (!canPreview) {
        hint = `Ansehen vor dem Senden geht nicht – dafür fehlt dir das Recht ${RENDER_LABEL}. Senden geht trotzdem.`;
    }
    return {canSend, canPreview, hint};
}
